import { isApiError } from '../../api';

/** Texto para falha do servidor (5xx): o corpo cru ("Erro interno") não diz nada útil a quem usa. */
export const SERVER_DOWN_MESSAGE =
  'O servidor está indisponível no momento. Tente de novo em instantes.';

/**
 * Mensagem para a pessoa quando uma chamada do painel falha. Erros do servidor (5xx) viram o texto
 * de "indisponível"; os demais (4xx, rede, tempo esgotado) já chegam em português do cliente HTTP
 * ou da API ("A nota está vazia", "Sem conexão…"). O que não é `ApiError` usa `fallback`.
 */
export function apiErrorMessage(error: unknown, fallback: string): string {
  if (!isApiError(error)) return fallback;
  if (error.status >= 500) return SERVER_DOWN_MESSAGE;
  return error.message;
}
